import { Record, fromJS } from 'immutable';

const defaultItems = fromJS({ root: {
  id: 'root',
  type: 'Body',
  props: {},
  children: []
}});


class LayoutState extends Record({ items: defaultItems, selectedItem: null }) {

  getItemJS(id) {
    const item = this.items.get(id);
    return item && item.toJS();
  }

  toRaw() {
    return this.items.toJS();
  }

}

LayoutState.fromRaw = raw => {
  let layoutState = new LayoutState();
  return layoutState.set('items', fromJS(raw));
};

export default LayoutState;



// WEBPACK FOOTER //
// ./src/contents/editorPreview/layout/model/LayoutState.js